import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      stroke-width={2}
      d="M12 2c5.5228 0 10 4.47715 10 10 0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10C2 6.47715 6.47715 2 12 2Z"
    />
    <path
      fill="currentColor"
      d="M16.1992 9.71681c.0976-.01962.1984-.01685.2949.00781.0964.02463.1861.07078.2627.13477.0763.06378.1377.14391.1797.23441.0418.0901.0635.1886.0635.2929-.0033.1617-.0619.3175-.166.4405-.1049.1236-.25.2064-.4063.2334-.9525.1764-1.9143.2961-2.8799.3574-.0607.0041-.1204.0206-.1748.0488-.0545.0283-.1032.0681-.1425.1162-.0394.0483-.0684.1047-.086.1651-.0088.0302-.0148.061-.0176.0888l-.0019.0391.0039.0605.081.7412c.102.9125.29 1.8129.5596 2.6866l.1045.3261.1133.3262.5273 1.4336c.0306.0839.0448.1734.041.2627-.0037.0892-.0259.1769-.0634.2578-.0377.081-.0905.1538-.1563.2139-.066.0603-.1434.1064-.2187.1328-.075.0298-.1553.0462-.2422.0469-.1295-.0025-.2553-.0437-.3623-.1172-.0599-.0412-.1132-.0912-.1602-.1553l-.0449-.0693-.0322-.0635-.1338-.292c-.364-.7957-.6967-1.5762-1-2.3486l-.1406-.3643-.1817.4697c-.0995.252-.2012.5035-.3056.7539l-.1582.375-.2442.5596-.2519.5557-.1202.2471c-.062.168-.1878.3051-.3496.3798-.1625.0751-.3484.0814-.51559.0176-.16652-.0636-.30094-.1918-.37403-.3555-.05023-.1125-.06906-.2362-.05273-.3662l.01465-.0791.0205-.0703.5273-1.4316c.3123-.8616.5419-1.7515.6856-2.6553l.0498-.3398.042-.3457.085-.7373c.0075-.0633.0019-.1275-.0157-.1885-.0175-.061-.0472-.1182-.0869-.167-.0393-.0484-.088-.0876-.1426-.1162-.0546-.0286-.1143-.0456-.1738-.0498-.9745-.0618-1.9447-.1829-2.90429-.3623-.08715-.016-.1709-.0499-.24512-.0987-.07386-.0485-.1378-.1111-.1875-.1845-.04959-.0734-.08362-.1564-.10156-.2432-.01795-.0867-.01954-.1761-.00391-.2598.01504-.0877.0473-.1718.09473-.247.04755-.07537.10978-.1405.18262-.19145.0729-.05093.15535-.08614.24219-.10449.08716-.01835.17799-.01888.26269-.00195 2.77955.52219 5.62975.52169 8.40625 0Zm-5.3936-3.57813c.6582-.66911 1.7267-.66913 2.3848 0 .6559.66701.656 1.74712 0 2.41407-.658.66887-1.7266.66874-2.3848 0-.656-.667-.656-1.74707 0-2.41407Z"
    />
  </svg>
);
export const A11YIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
